import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import _ from 'lodash';

import './BetInfo.scss';
import Icon from '../../Icon/Icon';
import Coupon from '../../Retail/OMR/Coupon';
import { RootState } from 'src/configs/store';

export default function BetInfo() {
  const { omr:{ data, showBetInfo } } = useSelector((state: RootState) => state.peripherals);

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const toggleButton = () => {
    dispatch.peripherals.changeBetInfo(!showBetInfo);
  };

  useEffect(() => {
    if (showBetInfo){
      document.body.classList.add('disable-scroll');
    } else {
      document.body.classList.remove('disable-scroll');
    }

    return () => {
      document.body.classList.remove('disable-scroll');
    };
  }, [showBetInfo]);

  return (
    <>
      <div className="betslip-info">
        <button
          onClick={ toggleButton }
          className={
            classNames({
              'betslip-info__btn': true,
              'betslip-info__btn--errors': data.infoblock.some((info) => info.infoName !== 'INFO'),
              'betslip-info__btn--open' : showBetInfo
            })
          }
        >
          <Icon icon="warning" />
        </button>
        <div
          className={
            classNames({
              'betslip-info__drawer': true,
              'betslip-info__drawer--open' : showBetInfo
            })
          }
        >
          <div className={
            classNames({
              'betslip-info__header': true,
              'betslip-info__header--errors': data.infoblock.some((info) => info.infoName !== 'INFO')
            })
          }
          >
            <Icon icon="warning" />
            <span className="betslip-info__title">{
              data.infoblock.some((info) => info.infoName !== 'INFO') ?
                `${ t('omr.errorsOnBetslip') } - ${ data.matrix.cardName }`:
                `${ t('omr.currentSelectedCard') } - ${ data.matrix.cardName }`
            }</span>
            <button
              className="betslip-info__close"
              onClick={ toggleButton }
            >-</button>
          </div>
          <div className="betslip-info__body">
            <Coupon matrix={ data.matrix } />
            <div className="betslip-info__read-info-container">
              {
                _.map(data?.infoblock, (info, key) => {
                  return (
                    <div
                      className={
                        classNames({
                          'betslip-info__read-info' : true,
                          'betslip-info__read-info--error': info.infoName !== 'INFO'
                        })
                      }
                      key={ key }
                    >
                      { `${ info.infoName } ${ info.infoCode } ${ info.infoTextFilled }` }
                    </div>
                  );
                }
                )
              }
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
